/**
 * Detect GovMap parcel ownership that indicates lease / land under Israel Land Authority (רמ"י),
 * for contextual UI (e.g. tips). GovMap "סוג בעלות" often uses values like "מקרקעי ישראל".
 */

function getGushHelka(searchResults) {
  if (!searchResults) return { gush: null, helka: null };
  const pd = searchResults.parcelData || {};
  return {
    gush: searchResults.gush ?? pd.gush ?? null,
    helka: searchResults.helka ?? pd.helka ?? null,
  };
}

function getAdvancedLayers(searchResults) {
  if (!searchResults) return null;
  return (
    searchResults.advancedLayers ||
    searchResults.parcelData?.advancedLayers ||
    null
  );
}

export function getMainParcelOwnershipRecord(searchResults) {
  const al = getAdvancedLayers(searchResults);
  const ownership = al?.ownership;
  if (!ownership?.length) return null;
  const { gush, helka } = getGushHelka(searchResults);
  if (gush != null && helka != null) {
    const match = ownership.find(
      (p) =>
        String(p['גוש']) === String(gush) && String(p['חלקה']) === String(helka)
    );
    if (match) return match;
  }
  return ownership[0];
}

/**
 * True when parcel ownership data suggests registration involving ILA / lease (not private freehold).
 */
export function isRegisteredAsIlaLease(searchResults) {
  const rec = getMainParcelOwnershipRecord(searchResults);
  const raw = rec?.['סוג בעלות'];
  if (raw == null || typeof raw !== 'string') return false;
  const s = raw.trim();
  if (!s || s === 'פרטית') return false;
  if (s.includes('מקרקעי ישראל')) return true;
  if (s.includes('ציבורית')) return true;
  if (s.includes('חכירה')) return true;
  if (s.includes('רמ"י')) return true;
  if (s.includes('מינהל מקרקעי')) return true;
  if (s.includes('רשות מקרקעי')) return true;
  return false;
}
